import { Color } from 'ng2-charts';
import { GraphPeriodType } from 'app/models';
import { MatRadioChange } from '@angular/material/radio';
import { ChartDataSets, ChartOptions, ChartType } from 'chart.js';
import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-chart-component',
  templateUrl: './chart.component.html',
  styleUrls: ['./chart.component.scss'],
})
export class ChartComponent {
  @Input()
  totalCutCreaseChartDataSets: Array<ChartDataSets> = [];

  @Input()
  totalCutCreaseChartLabels: string[] = [];

  @Input()
  sumOfJobsChartLabels: string[] = [];

  @Input()
  sumOfJobsChartDataSets: Array<ChartDataSets> = [];

  @Input()
  selectedPeriod = GraphPeriodType.DAILY;

  @Output()
  selectedPeriodChanged = new EventEmitter<MatRadioChange>();

  graphPeriods: string[] = Object.values(GraphPeriodType);

  chartType: ChartType = 'bar';

  chartOptions: ChartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      xAxes: [
        {
          gridLines: { color: 'rgba(255,255,255,0.1)' },
        },
      ],
      yAxes: [
        {
          gridLines: { color: 'rgba(255,255,255,0.1)' },
          ticks: {
            min: 0,
          },
        },
      ],
    },
  };

  sumOfJobsChartColors: Color[] = [
    {
      // grey
      backgroundColor: 'rgba(148,159,177,0.2)',
      borderColor: 'rgba(148,159,177,1)',
      pointBackgroundColor: 'rgba(148,159,177,1)',
      pointBorderColor: '#fff',
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: 'rgba(148,159,177,0.8)',
    },
  ];

  totalCutCreaseChartColors: Color[] = [
    {
      // dark grey
      backgroundColor: 'rgba(77,83,96,0.2)',
      borderColor: 'rgba(77,83,96,1)',
      pointBackgroundColor: 'rgba(77,83,96,1)',
      pointBorderColor: '#fff',
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: 'rgba(77,83,96,1)',
    },
  ];

  handeSelectedPeriodChanged(event: MatRadioChange) {
    this.selectedPeriodChanged.emit(event);
  }
}
